import { Components, Theme } from '@mui/material';

export const MuiTableCell: Components<Theme>['MuiTableCell'] = {
  styleOverrides: {
    head: {
      overflowWrap: 'break-word',
    },
  },
};
